import {Injectable} from '@angular/core';
import {AppConfigService} from '../../../../services/config.service';
import {DEX_EMPTY_ADDR} from '../../../dex/dex-streaming/const';
import {Deliverable} from '../../../dex/dex-streaming/types/deliverable';
import {DeliverableCommonFilter} from './deliverable-common-filter';

@Injectable()
export class DeliverableWalletFilter implements DeliverableCommonFilter {

    public query: boolean = true;

    private readonly nativeSymbol = this.appConfigService.appConfig.dex.chain.nativeCurrency.symbol;

    constructor(
        private readonly appConfigService: AppConfigService
    ) {}

    public apply(): void {
        // Not implemented.
    }

    public match(item: Deliverable): boolean {
        return item.identifier !== DEX_EMPTY_ADDR
            || item.symbol === this.nativeSymbol;
    }

}
